import { Reducer } from 'redux';

export type TActiveScreen = 'categoriesGroups' | 'subscriptions';

export interface IActiveScreenChange {
  type: 'IActiveScreenChange';
  activeScreen: TActiveScreen;
}

export function changeActiveScreen(activeScreen: TActiveScreen): IActiveScreenChange {
  return {
    activeScreen,
    type: 'IActiveScreenChange',
  };
}

export type TActiveScreenActions = IActiveScreenChange;

const initialState = 'categoriesGroups' as TActiveScreen;

export const activeScreenReducer: Reducer<TActiveScreen, TActiveScreenActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'IActiveScreenChange':
      return action.activeScreen;

    default:
      return state;
  }
};
